/* eslint-disable */
/* eslint-disable react/prop-types */
import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import {
  CCard,
  CCardBody,
  CCardImage,
  CCardSubtitle,
  CCardTitle,
  CCol,
  CRow
} from '@coreui/react';
import colors from 'utils/colors';

function Items({ language, division }) {
  const router = useRouter();
  const pathname = router.asPath.split('/').pop();

  return (
    <div className="content contents-pages-career">
      <div className="col-our-office-location">
        <div className="container">
          <CRow>
            <CCol>
              <h1>
                {language === 'EN' ? 'Job Vacancy' : 'Lowongan Pekerjaan'}
              </h1>
            </CCol>
          </CRow>
          <div className="mt-3">
            <div className="row">
              {division?.state?.map((item, index) => (
                <div className="col-sm-6 col-md-3" key={index}>
                  {item?.position_count === '0' ? (
                    <CCard
                      className="cards-for-careers"
                      style={{
                        // width: "350px",
                        boxShadow: `0px 0px 15px ${colors.gray2}`,
                        marginBottom: '50px'
                      }}
                    >
                      <CCardImage
                        className="image-blogs"
                        height="300"
                        orientation="top"
                        src={item?.img}
                      />
                      <CCardBody className="card-body card-body-blogs">
                        <center>
                          <CCardTitle
                            dangerouslySetInnerHTML={{
                              __html: item?.name
                            }}
                          ></CCardTitle>
                          <CCardSubtitle
                            dangerouslySetInnerHTML={{
                              __html: item?.position_count
                                ? item?.position_count + ' Positions'
                                : ''
                            }}
                            className="mb-2 text-medium-emphasis"
                          ></CCardSubtitle>
                        </center>
                      </CCardBody>
                    </CCard>
                  ) : (
                    <Link
                      href={item?.id ? '/career/detail/' + item?.id : null}
                      locale={language === 'ID' ? 'id' : 'en'}
                    >
                      <a>
                        <CCard
                          className="cards-for-careers"
                          style={{
                            // width: "350px",
                            boxShadow: `0px 0px 15px ${colors.gray2}`,
                            marginBottom: '50px',
                            cursor: 'pointer'
                          }}
                        >
                          <CCardImage
                            className="image-blogs"
                            height="300"
                            orientation="top"
                            src={item?.img}
                          />
                          <CCardBody className="card-body card-body-blogs">
                            <center>
                              <CCardTitle
                                dangerouslySetInnerHTML={{
                                  __html: item?.name
                                }}
                              ></CCardTitle>
                              <CCardSubtitle
                                dangerouslySetInnerHTML={{
                                  __html: item?.position_count
                                    ? item?.position_count + ' Positions'
                                    : ''
                                }}
                                className="mb-2 text-medium-emphasis"
                              ></CCardSubtitle>
                            </center>
                          </CCardBody>
                        </CCard>
                      </a>
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Items;
